import { render, staticRenderFns } from "./SendingCategoryDrillDown.vue?vue&type=template&id=4eb58329"
import script from "./SendingCategoryDrillDown.vue?vue&type=script&lang=js"
export * from "./SendingCategoryDrillDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports